import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import Catalog from "@/components/site/Catalog";
import Pricing from "@/components/site/Pricing";
import CTABanner from "@/components/site/CTABanner";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import ChatWidget from "@/components/site/ChatWidget";
import SectionDivider from "@/components/site/SectionDivider";
import ScrollExcavator from "@/components/site/ScrollExcavator";

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900 font-body antialiased">
      <Header />
      <main>
        <Hero />
        <SectionDivider />
        <Pricing />
        <Catalog />
        <Features />
        <CTABanner />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <ScrollExcavator />
    </div>
  );
}

export default App;
